<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalModalStore } from '../../store/globalModal.store'

const props = withDefaults(defineProps<{
  title?: string
  shortcut?: string
  width?: string
}>(), {
  title: 'Modal',
  shortcut: 'F2',
  width: '50%'
})

const store = useGlobalModalStore()
const { isOpen } = storeToRefs(store)

function handleKeyDown(e: KeyboardEvent) {
  if (e.key === props.shortcut) {
    e.preventDefault()
    store.toggle()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
})
</script>

<template>
  <el-dialog
    v-model="isOpen"
    :title="title"
    :width="width"
    :close-on-click-modal="true"
    :append-to-body="true"
    destroy-on-close
  >
    <slot />
  </el-dialog>
</template>
